import { render, staticRenderFns } from "./IncidentDetails.vue?vue&type=template&id=5cb6745a&"
import script from "./IncidentDetails.vue?vue&type=script&lang=ts&"
export * from "./IncidentDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports